'use strict';

wbApp.controller('PreviewHoursCtrl', ['$q', '$scope', '$modal', '$translate', '$filter', 'previewHoursSvc', 'semesterSvc', 'stateCodesSvc', 'gridSortSvc',
function ($q, $scope, $modal, $translate, $filter, previewHoursSvc, semesterSvc, stateCodesSvc, gridSortSvc) {

    var activeSemesterPromise = semesterSvc.getDefaultAsync();
    var stateCodes = stateCodesSvc.getAllAsync();

    $q.all([activeSemesterPromise, stateCodes.$promise]).then(function (data) {
        var activeSemester = data[0];
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
        } else {
            $scope.semesterID = null;
        }

        $scope.previewHours = previewHoursSvc.getAllForClassroomAsync(
            activeSemester != null ? activeSemester.id : null,
            $scope.classroomID);

        $scope.selectedRow = null;
    });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            $scope.previewHours = previewHoursSvc.getAllForClassroomAsync($scope.semesterID, $scope.classroomID, true);
            $scope.selectedRow = null;
        }
    });

    $scope.onSemesterChange = function (semesterId) {
        if (semesterId) {
            $scope.previewHours = previewHoursSvc.getAllForClassroomAsync(semesterId, $scope.classroomID);
            $scope.selectedRow = null;
        }
    }

    $scope.onClassroomChange = function (classroomID) {
        if ($scope.semesterID) {
            $scope.previewHours = previewHoursSvc.getAllForClassroomAsync($scope.semesterID, classroomID);
            $scope.selectedRow = null;
        }
    }

    $scope.gridSettings = {
        name: 'previewHours',
        columns: [
            {
                dataField: 'student', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '140px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'student') },
                sortOrder: 'desc'
            },
            {
                dataField: 'parent', caption: $translate.instant('TXT_LBL_PARENT'), dataType: 'string', width: '140px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'parent') }
            },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '120px'
            },
            { dataField: 'course', caption: $translate.instant("TXT_LBL_COURSE"), dataType: 'string' },            
            { dataField: 'lesson', caption: $translate.instant('TXT_LBL_LESSON'), dataType: 'date', format: { raw: "dd.MM.yy HH:mm" }, width: '110px' },
            {
                dataField: 'status',
                caption: $translate.instant('TXT_LBL_PRESENT'),
                dataType: 'string',
                alignment: 'left',
                calculateCellValue: function (rowData) {
                    return $filter('attendanceStatus')(rowData.status);
                },
                width: '100px'
            },
            { dataField: 'nextContact', caption: $translate.instant('TXT_LBL_NEXT_CONTACT'), dataType: 'date', format: { raw: "dd.MM.yy HH:mm" }, width: '110px' },
            { dataField: 'note', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            {
                dataField: 'regCourseID',
                caption: $translate.instant('TXT_LBL_REG'),
                dataType: 'boolean',
                calculateCellValue: function (rowData) {
                    return !!rowData.regCourseID;
                },
                width: '60px'
            },
            {
                dataField: 'state',
                caption: $translate.instant('TXT_LBL_STATE'),
                dataType: 'string',
                alignment: 'left',
                calculateCellValue: function (rowData) {
                    return $filter('previewStateCode')(rowData.state);
                },
                width: '100px'
            },
            { dataField: 'referenceSource', caption: $translate.instant('TXT_LAB_REFERENCE_SOURCE'), dataType: 'string', width: '130px', visible: true },
        ],
        customCommands: [{
            text: $translate.instant('TXT_MENU_REGISTER_ON_COURSE'),
            isVisible: function (selected) { return !!selected && !selected.regCourseID },
            callback: function (row) { $scope.onRegisterOnCourse(row); }
        }, {
            text: $translate.instant('TXT_MENU_ATTENDANCE_EXCUSE'),
            isVisible: function (selected) { return !!selected && selected.status === 0 },
            callback: function (row) { $scope.onAttendanceExcuse(row); }
        }, {
            text: $translate.instant('TXT_MENU_ATTENDANCE_BOOK_AGAIN'),
            isVisible: function (selected) { return !!selected && selected.status !== 0 },
            callback: function (row) { $scope.onAttendanceBookAgain(row); }
        }],
        onExporting: function (e) {
            e.component.beginUpdate();
            prepareGridForExport(e.component);
        },
        onExported: function (e) {
            cleanGridAfterExport(e.component);
            e.component.endUpdate();
        },
    }

    var origColLength = -1;

    function prepareGridForExport(grid) {
        for (var i = origColLength + 1; i < grid.columnCount(); i++) {
            grid.columnOption(i, "visible", true);
        }
    }

    function cleanGridAfterExport(grid) {
        for (var i = origColLength + 1; i < grid.columnCount(); i++) {
            grid.columnOption(i, "visible", false);
        }
    }

    function extendGrid() {
        origColLength = $scope.gridSettings.columns.length;
        stateCodes.$promise.then(function (result) {
            for (var idx = 0; idx < stateCodes.length; idx++) {
                var stateCodeName = stateCodes[idx].name;
                $scope.gridSettings.columns.push({
                    dataField: 'state',
                    caption: stateCodeName,
                    dataType: 'boolean',
                    alignment: 'left',
                    calculateCellValue: function (rowData) {
                        var stateModel = stateCodesSvc.get(rowData.state);
                        return !!stateModel && stateModel.name == this.caption;
                    },
                    width: '50px',
                    visible: false
                });
            }
        });
    }

    extendGrid();

    //#region Detail

    $scope.previewHoursDetail = { state: 0, nextContact: new Date(), note: "" };

    $scope.onRowEdit = function (data) {
        $scope.previewHoursDetail = angular.copy(data);

        // TODO: remove me when datepicker is fixed
        $scope.previewHoursDetail.nextContact = !!data.nextContact ? data.nextContact : new Date();

        $scope.previewHoursDetailOrig = angular.copy($scope.previewHoursDetail);
        
        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.detailError = null;

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.previewHoursDetailOrig);
    }

    $scope.onPreviewHoursDetailSave = function (data) {
        previewHoursSvc.update(data, function (successResult) {
            detailDialogPromise.hide();
        }, function (errorResult) {
            $scope.detailError = errorResult;
        });
    }

    $scope.onRowDelete = function (data) {
        previewHoursSvc.remove(data);
    }

    //#endregion

    //#region Register on course

    $scope.previewHoursRegOnCourse = {};
    $scope.previewHoursRegOnCourseOrig;

    $scope.onRegisterOnCourse = function (data) {
        $scope.previewHoursRegOnCourse.regCourseSemesterID = data.regCourseSemesterID != null
            ? data.regCourseSemesterID
            : $scope.semesterID;
        $scope.previewHoursRegOnCourse.regCourseID = data.regCourseID != null 
            ? data.regCourseID
            : $scope.selectedRow.courseID;

        $scope.previewHoursRegOnCourseOrig = angular.copy($scope.previewHoursRegOnCourse);

        detailRegisterOncoursePromise.$promise.then(function () {
            $scope.registerOnCourseError = null;
            detailRegisterOncoursePromise.show();
        });
    }

    $scope.onRegisterOnCourseSave = function (data) {
        var payload = angular.copy(data);

        payload.studentID = $scope.selectedRow.studentID;
        payload.courseScheduleID = $scope.selectedRow.courseScheduleID;
        $scope.registerOnCourseError = null;

        previewHoursSvc.registerOnCourse(payload, function (successResult) {
            detailRegisterOncoursePromise.hide();
        }, function (errorResult) {
            $scope.registerOnCourseError = errorResult;
        });
    }

    //#endregion

    //#region Book preview

    $scope.previewHoursBookPreview = {};
    $scope.previewHoursBookPreviewOrig;

    $scope.onBookPreview = function (data) {

        $scope.previewHoursBookPreview.studentID = null;
        $scope.previewHoursBookPreview.courseID = null;
        $scope.previewHoursBookPreview.courseScheduleID = null;
        $scope.previewHoursBookPreview.semesterID = $scope.semesterID;

        $scope.previewHoursBookPreviewOrig = angular.copy($scope.previewHoursBookPreview);

        detailBookPreviewPromise.$promise.then(function () {
            $scope.bookPreviewError = null;
            detailBookPreviewPromise.show();
        });
    }

    $scope.bookPreviewIsUnchanged = function (data) {
        return angular.equals(data, $scope.previewHoursBookPreviewOrig);
    }

    $scope.onBookPreviewSave = function (data) {
        previewHoursSvc.insert(data, function (successResult) {
            detailBookPreviewPromise.hide();
        }, function (errorResult) {
            $scope.bookPreviewError = errorResult;
        });
    }

    //#endregion

    //#region Attendance Excuse

    $scope.onAttendanceExcuse = function (data) {
        $scope.attendanceExcuseData = angular.copy(data);

        dlgExcuseConfirmationPromise.$promise.then(function () {
            dlgExcuseConfirmationPromise.show();
        });
    }

    var dlgExcuseConfirmationPromise = $modal({
        templateUrl: 'preview-hours/preview-hours-confirm-excuse-dlg.html',
        show: false,
        scope: $scope
    });

    $scope.onConfirmExcuse = function (data) {
        previewHoursSvc.excuseFromLesson(data);
    }

    //#endregion

    //#region Attendance Book Again

    $scope.onAttendanceBookAgain = function (data) {
        $scope.attendanceBookAgainData = angular.copy(data);

        dlgReBookConfirmationPromise.$promise.then(function () {
            dlgReBookConfirmationPromise.show();
        });
    }

    $scope.onConfirmBookAgain = function (data) {
        previewHoursSvc.bookOnLessonAgain(data);
    }

    var dlgReBookConfirmationPromise = $modal({
        templateUrl: 'preview-hours/preview-hours-confirm-rebook-dlg.html',
        show: false,
        scope: $scope
    });

    //#endregion

    $scope.selectedRow = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedRow = data;
    }

    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "preview-hours/detail-tabs/home.html"
        },
        {
            title: "TXT_NOTE",
            template: "preview-hours/detail-tabs/note.html"
        },
        {
            title: "TXT_SUCCESS_STATS",
            template: "preview-hours/detail-tabs/success-stats.html"
        }
    ];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    var detailBookPreviewPromise = $modal({
        templateUrl: 'preview-hours/preview-hours-book-preview.html',
        show: false,
        scope: $scope
    });

    var detailRegisterOncoursePromise = $modal({
        templateUrl: 'preview-hours/preview-hours-register-on-course.html',
        show: false,
        scope: $scope
    });

    var detailDialogPromise = $modal({
        templateUrl: 'preview-hours/preview-hours-detail.html',
        show: false,
        scope: $scope
    });

    function getStateCodesNames(stateCodes) {
        var ret = [];
        stateCodes.$promise.then(function (result) {
            for (var idx = 0; idx < stateCodes.length; idx++) {
                var stateCode = stateCodes[idx];
                ret.push(stateCode.name);
            }
        });
        return ret;
    }
}]);